<template lang="pug">

include ./recommended

</template>

<script>

import List from './alphabet-list'
import Translatable from '@shared/mixins/translatable'

export default {
  extends: List,
  mixins: [Translatable],
}

</script>



// WEBPACK FOOTER //
// src/js/shared/components/alphabet/recommended.vue